import { Extension } from '@tiptap/core';

// ═══════════════════════════════════════════════════════════════
// Indent — odsazení odstavce/nadpisu (jako Word, ne jen seznamy).
//
// Přidává atribut `indent` (úroveň 0–8) na paragraph a heading, který se
// renderuje jako inline `margin-left`. Krok = 2,5 cm dělený na rozumné
// jednotky; zde volíme 40px na úroveň (~1 cm) pro plynulý pocit.
//
// Ribbon: pokud je kurzor v seznamu, použije se nativní sink/lift; jinak
// tento indent (viz ribbon.ts).
// ═══════════════════════════════════════════════════════════════

const STEP = 40; // px na úroveň
const MAX = 8;

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      indentMore: () => ReturnType;
      indentLess: () => ReturnType;
    };
  }
}

export const Indent = Extension.create({
  name: 'indent',

  addOptions() {
    return { types: ['paragraph', 'heading'] };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => {
              const ml = parseInt(element.style.marginLeft || '0', 10);
              return ml ? Math.round(ml / STEP) : 0;
            },
            renderHTML: (attributes) => {
              if (!attributes.indent) return {};
              return { style: `margin-left: ${attributes.indent * STEP}px` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      indentMore:
        () =>
        ({ editor, commands }) => {
          const { indent = 0 } = editor.getAttributes('paragraph');
          const { indent: hIndent = 0 } = editor.getAttributes('heading');
          const current = Math.max(indent, hIndent);
          const next = Math.min(current + 1, MAX);
          return commands.updateAttributes(
            editor.isActive('heading') ? 'heading' : 'paragraph',
            { indent: next },
          );
        },
      indentLess:
        () =>
        ({ editor, commands }) => {
          const { indent = 0 } = editor.getAttributes('paragraph');
          const { indent: hIndent = 0 } = editor.getAttributes('heading');
          const current = Math.max(indent, hIndent);
          const next = Math.max(current - 1, 0);
          return commands.updateAttributes(
            editor.isActive('heading') ? 'heading' : 'paragraph',
            { indent: next },
          );
        },
    };
  },
});
